// ========= plugin import ====== //
import {useState, useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios'
// ========== component import ========== //
import AssociateServiceAttributesForm from './component/AssociateServiceAttributesForm';
import AssociateServiceAttributesList from './component/AssociateServiceAttributesList';

const AssociateServicesWithAttributes = (props) => {

    const {
        formData, 
        formValidateError,
        productFeatureAssApiIsCall,
        pfAssSetupApiIsCall
    } = props;
    const api_base_url = process.env.REACT_APP_API_URL;
    const loginUserType = localStorage.getItem('type');

    // ----- define all state ----- //
    const [ serviceAttributesAssociationChange, setServiceAttributesAssociationChange ] = useState(false);
    const [ serviceAttributeAssociateData, setServiceAttributeAssociateData] = useState({});

    const [isButtonLoader, setIsButtonLoader] = useState(false);

    const serviceAttributeAssociateSaveHandler = (associateData) => {

        if(Object.keys(associateData).length === 0) return;
        setServiceAttributesAssociationChange(true)
        setIsButtonLoader(true)
        const serAttAssManage = Object.keys(associateData).reduce((acc, key, index) => {
            acc[key] = {
                ...associateData[key],
                index: index,
            };
            return acc;
        }, {});

        const updatedState = { ...serviceAttributeAssociateData, ...serAttAssManage };
        setServiceAttributeAssociateData(updatedState)
        props.onInputChange(
            'step4',
            'service_attributes_association',
            updatedState
        );
    }
    
    const serviceAttributeAssociateDeleteHandler = (serviceName) => {
       
        setServiceAttributesAssociationChange(true)
        const updatedAssociationData = { ...serviceAttributeAssociateData };

        // ------- delete service_attributes_association_setup -------- //
        const pfAssData = formData['step4'].service_attributes_association_setup;
        if(pfAssData.length > 0){
            props.serviceAttributeAssSetupApiCall(true)
            const filterService = (data, serviceToRemove) => {
                return data
                    .map((item) => ({
                    ...item,
                    service_attribute_association: item.service_attribute_association.filter(
                        (assoc) => !assoc.value.includes(`Service: ${serviceToRemove}`)
                    ),
                }))
                .filter((item) => item.service_attribute_association.length > 0);
            };
            const pfAssDataUpdate =  filterService(pfAssData, serviceName);
            props.onInputChange('step4', 'service_attributes_association_setup', pfAssDataUpdate);
        }
        // ------ delete service_attributes_association ------- //
        delete updatedAssociationData[serviceName];
        setServiceAttributeAssociateData(updatedAssociationData)
        props.onInputChange(
            'step4',
            'service_attributes_association',
            updatedAssociationData
        );
    }

    useEffect(() => {
        setServiceAttributesAssociationChange(false)
        setServiceAttributeAssociateData(formData['step4'].service_attributes_association)
    },[formData['step4']]);

    useEffect(() => {
        const saveProductFeatureAssociation = async () => {
            if(
                !serviceAttributesAssociationChange && 
                !productFeatureAssApiIsCall &&
                !pfAssSetupApiIsCall 
            ) return;
            const saveAssociationData = async () => {
                const updatedState = Object.keys(serviceAttributeAssociateData).reduce((acc, key, index) => {
                    const existingData = serviceAttributeAssociateData[key]; 
                    acc[key] = {
                        ...existingData,
                        attribute_list: Array.isArray(existingData.attribute_list) ? existingData.attribute_list : [],
                        index: index,
                    };
                    return acc;
                }, {});
                let apiToken = '';
                if(loginUserType === 'A'){
                    apiToken = localStorage.getItem('token')
                }
                else if(loginUserType === 'D'){
                    apiToken = localStorage.getItem('developertoken')
                }
                else if(loginUserType === 'SA') {
                    apiToken = localStorage.getItem('systemAdminToken')
                }
                let associationFormData = new FormData();
                associationFormData.append("action_type", 'service_attributes_association');
                associationFormData.append("bot_id", formData.bot_id);
                associationFormData.append("step", "step4");
                associationFormData.append("data", JSON.stringify(updatedState));
                associationFormData.append("sass_id", localStorage.getItem('sass_id'));
                associationFormData.append("user_type", localStorage.getItem('type'));
                associationFormData.append("user_name", loginUserType == 'SA' ? localStorage.getItem('system_username') : '');
                const apiHeaders = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "x-access-token": apiToken,
                    },
                };
                try {
                    await axios.post(`${api_base_url}api/save-bot-details`, associationFormData, apiHeaders)
                    .then(async (res) => {
                        if(res.data.status === 'success'){
                            associationFormData = new FormData();
                            setServiceAttributesAssociationChange(false)
                            props.serviceAttributeAdd(false)
                            setIsButtonLoader(false)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                } catch (error) {
                    console.error("Error during save:", error);
                }
            }
            await saveAssociationData();
        }
        saveProductFeatureAssociation();
    },[serviceAttributeAssociateData, productFeatureAssApiIsCall, pfAssSetupApiIsCall])

    return (
        <>
            {
                formData['step4'].service_setup.length > 0 &&
                <div className="row mb-5 border border-dashed border-gray-400 rounded p-5">
                    <div className='col-md-6'>
                        <a className="fw-bold text-gray-800 mb-2 fs-3 required">
                            Add Associate Services with Attributes
                        </a>
                    </div>
                    <div className='col-md-6 text-end'>
                        <FontAwesomeIcon
                            icon={faCircleInfo}
                            className='cursor-pointer text-gray-600'
                            onClick={(e) => props.infoOpenOnCLick('associate_services_with_attributes')}
                        />
                    </div>
                    <div className='col-md-12'>
                        <AssociateServiceAttributesForm
                            formData={formData}
                            formValidateError = {formValidateError}
                            serviceAttributeAssociateSave={serviceAttributeAssociateSaveHandler}
                            isButtonLoader={isButtonLoader}
                        />
                    </div>
                    <div className='col-md-12'>
                        <AssociateServiceAttributesList 
                            serviceAttributeAssociateData={serviceAttributeAssociateData}
                            serviceAttributeAssociateDelete={serviceAttributeAssociateDeleteHandler}
                            formData={formData}
                        />
                    </div>
                </div>
            }
        </>
    )
}

export default AssociateServicesWithAttributes
